import { atom } from 'jotai';

export type CheckoutErrorType = 'session_conflict' | null;

export const checkoutErrorAtom = atom<CheckoutErrorType>(
  null as CheckoutErrorType
);
